import {useEffect, useState, useMemo} from "react";

export const usePagination = (data) => {
  const { firstRequest = true, key = null, customParams = {} } = data;
  const [state, setState] = useState([]);

  const [result, setResult] = useState({});

  // пагинация
  const [params, setParams] = useState({
    totalCount: 0, //есть всего элементов
    currentPage: 1, //текущая страница
    perPage: 20, // количество элементов на странице
  });

  const totalPages = useMemo(() => {
          if (params.perPage == 0 || params.totalCount == 0) return 1;
          return Math.ceil(params.totalCount / params.perPage);
      }, [params.totalCount, params.perPage]);

  const setPerPage = (value) => {
    setParams((prev) => ({
        ...prev,
        perPage: value
    }))
  } 
  
  const setCurrentPage = (value) => {
    setParams((prev) => ({
        ...prev,
        currentPage: value
    }))
  }

  const nextPage = () => {
      setParams((prev) => ({
        ...prev,
        currentPage: Math.min(prev.currentPage + 1, totalPages)
      }))
  }
  const prevPage = () => {
      setParams((prev) => ({
        ...prev,
        currentPage: Math.max(prev.currentPage - 1, 1)
      }))
  }

  const [loading, setLoading] = useState(false);

  // метод загрузки
  const getState = (options = {}) => {
    const { customParams = {} } = options;
    setState([]);
    setLoading(true);
    const dataParams = {
        ...data.params,
        ...customParams,
        paramsPagination: {
            perPage: params.perPage,
            page: params.currentPage
        }
    }
    data.api(dataParams).then((res) => {
      setLoading(false);
      let listData;
      if (res?.data?.payments) {
        listData = res?.data.payments;
      } else {
        listData = key ? res?.data[key] : res?.data;
      }

      if (key) setResult(res?.data);

      if (listData?.data !== undefined) {
        setState(listData.data);
        if(listData?._meta?.totalCount !== params.totalCount){
            setParams((prev) => (
                {   
                    ...prev,
                    totalCount: listData?._meta?.totalCount,
                }
            ));
        }
      }
    });
  };

  const [firstRenred, setFirstRenred] = useState(!firstRequest);
  useEffect(()=>{
    if(firstRenred){
      setFirstRenred(false);
      return;
    }
    if(data.api){
      getState(customParams);
    }
  }, [params.currentPage, params.perPage]);

  return {
    state,
    getState,
    setState,
    loading,
    result,

    totalCount: params.totalCount,
    perPage: params.perPage,
    currentPage: params.currentPage,
    setPerPage,
    setCurrentPage,
    prevPage,
    nextPage,
    totalPages
  };
};

export default usePagination;